var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconmutuellobottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16389 9.37662C4.03596 8.83932 0.348652 7.28893 0.209199 4.35221C0.0574408 1.19811 6.31232 0.792051 6.80041 0.726426C6.81682 0.722325 6.83732 0.722326 6.85373 0.718224C7.40744 0.669005 8.10881 0.652598 8.85939 0.558262C9.60178 0.463926 11.9315 0.468028 18.9164 0.1317C19.4168 0.107091 19.8721 0.427012 20.11 0.865879C20.2987 1.21861 20.4545 1.60826 20.4668 1.80924C20.4668 1.82975 20.4668 1.85026 20.4668 1.86666C20.4668 2.61725 19.8475 3.22018 19.0969 3.22838C18.3955 3.23658 12.559 3.62213 11.9889 3.64674C11.349 3.67545 7.19006 3.88463 6.46408 3.91334L5.05314 3.98307C3.60529 4.05279 2.68244 4.30299 2.71525 4.97154C2.76857 6.07076 5.11877 7.56783 7.44846 8.67115C7.69045 8.77779 7.77248 8.85162 7.77658 8.97057C7.78889 9.24537 7.09572 9.47506 6.39025 9.50787L6.15646 9.52018C5.79963 9.54068 5.40178 9.48326 5.16389 9.37662Z",
    fill: "url(#paint0_diamond_8682_67688)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_8682_67688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.48 1.60006) rotate(168.44) scale(18.8626 40.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267351,
    stopColor: "#FD8408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515989,
    stopColor: "#E4C400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809081,
    stopColor: "#15B32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#547EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmutuellobottom);
export default __webpack_public_path__ + "static/media/iconmutuellobottom.ced0635aae160a3dc786d6c33498a6c5.svg";
export { ForwardRef as ReactComponent };